import {Col, Row} from 'antd';
import React from 'react';

import BoxContent from '../../../../../../components/BoxContent/BoxContent';
import InformativeText from '../../../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../../../utils/commonFunctions';
import TotalChartList from '../../../../components/TotalChartList';
import ValueRepresentationBox from '../../../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../../../constants/commonConstants';

const OperationalWaste: React.FC<{data: any[]}> = ({data}) => {
  const wasteInfo = InformativeText?.NZM?.utility?.waste;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(400)}}>
        <Col span={8}>
          <TotalChartList
            data={data}
            keyArray={[
              'total waste disposal',
              'waste disposal onsite/offsite',
              'waste directed to disposal'
            ]}
            chartType="pie"
            customTotalTitle="TOTAL WASTE GENERATED"
          />
        </Col>
        <Col span={8} style={{height: '100%'}}>
          <TotalChartList
            data={data}
            keyArray={[
              'total waste treatment',
              'waste landfilled',
              'waste recycled',
              'waste incinerated',
              'waste reused'
            ]}
            chartType="donut"
            customTotalTitle="DIRECTED TO DISPOSAL"
          />
        </Col>
        <Col span={8}>
          <TotalChartList
            data={data}
            keyArray={[
              'waste generation by state of matter',
              'solid waste',
              'liquid waste'
            ]}
            chartType="pie"
            customTotalTitle="TOTAL WASTE"
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(433)}}>
        <Col span={24}>
          <TotalChartList
            chartType="compositeStraight"
            showTotal={false}
            keyArray={['waste generation type']}
            data={data}
            dataInMainData={true}
            showChartList={false}
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(433)}}>
        <Col span={12}>
          <TotalChartList
            chartType="bar"
            showTotal={false}
            keyArray={['waste treated by each treatment methods']}
            data={data}
            dataInMainData={true}
            showChartList={false}
          />
        </Col>
        <Col span={8} style={{height: '100%'}}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(433)}}>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="waste per employee"
                smallImage={true}
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="waste per unit of production"
                smallImage={true}
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="waste emission"
                smallImage={true}
                tooltip={wasteInfo?.Waste_emissions}
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="waste emission intensity"
                smallImage={true}
                tooltip={wasteInfo?.Waste_emissions_intensity}
              />
            </Col>
          </Row>
        </Col>
        <Col span={4}>
          <BoxContent />
        </Col>
      </Row>
    </>
  );
};

export default OperationalWaste;
